import { Display } from '@/components/Display/Display';

import MobileChatFiles from '@/pages/Mobile/PageComponents/AgentFile/ChatFiles';
import WebChatFiles from '@/pages/Web/PageComponents/AgentFile/ChatFiles';
const ChatFiles = (props) => {
    return (
        <>
            <Display show={props.side === 'mobile'}>
                <MobileChatFiles {...props}></MobileChatFiles>
            </Display>
            <Display show={props.side === 'web'}>
                <WebChatFiles {...props}></WebChatFiles>
            </Display>
        </>
    );
};
export default ChatFiles;
